module.exports = __webpack_public_path__ + "img/visuel-mysam.6e22776.png";